import {
  type Icon,
  IconActivity,
  IconBeach,
  IconBell,
  IconBrandApple,
  IconBrandGoogle,
  IconBrandSlack,
  IconBrandTelegram,
  IconBriefcase,
  IconCake,
  IconCalendar,
  IconCategory,
  IconCheck,
  IconCheckupList,
  IconChevronDown,
  IconChevronLeft,
  IconChevronRight,
  IconChevronUp,
  IconClock,
  IconCoffee,
  IconConfetti,
  IconCopy,
  IconDotsVertical,
  IconDownload,
  IconEdit,
  IconExternalLink,
  IconEyeOff,
  IconFileExport,
  IconFileInfo,
  IconFilter,
  IconFolder,
  IconHeart,
  IconHelp,
  IconHome,
  IconKey,
  IconLanguage,
  IconLink,
  IconList,
  IconLoader,
  IconLock,
  IconLogout,
  IconMail,
  IconMap,
  IconMessage,
  IconMoon,
  IconPhone,
  IconPlayerPlay,
  IconPlus,
  IconRadio,
  IconReceipt,
  IconRefresh,
  IconRepeat,
  IconReport,
  IconSearch,
  IconSend,
  IconSettings,
  IconSitemap,
  IconSpy,
  IconStar,
  IconSun,
  IconThumbUp,
  IconUser,
  IconUserCheck,
  IconUserSquare,
  IconUsers,
  IconWind,
  IconWorld,
  IconX,
} from "@tabler/icons-react"
import type { TActivityType } from "@/types/activities"

export const activityIcons: Record<TActivityType, Icon> = {
  anniversary: IconCalendar,
  coffee: IconCoffee,
  experience: IconPlayerPlay,
  feedback: IconUserCheck,
  party: IconConfetti,
  pulse: IconActivity,
  radio: IconRadio,
  recognition: IconThumbUp,
  reimbursement: IconReceipt,
  survey: IconCheckupList,
  vacation: IconBeach,
  people: IconUsers,
  onboarding: IconLoader,
  playbook: IconPlayerPlay,
  other: IconHome,
}

export function ActivityIcon({ type, ...props }: { type: TActivityType } & React.ComponentProps<Icon>) {
  const IconComponent = activityIcons[type] || icons.other
  return <IconComponent {...props} />
}

export const icons = {
  ...activityIcons,

  Anonymous: IconEyeOff,
  Billing: IconReceipt,
  Birthday: IconCake,
  Company: IconBriefcase,
  External: IconExternalLink,
  General: IconHome,
  Message: IconMessage,
  OrgChart: IconSitemap,
  Profile: IconUserSquare,
  Recurrence: IconRepeat,

  // Color schemas
  Dark: IconMoon,
  Light: IconSun,

  // Controls
  Add: IconPlus,
  Calendar: IconCalendar,
  Copy: IconCopy,
  Bell: IconBell,
  Down: IconChevronDown,
  Download: IconDownload,
  Edit: IconEdit,
  Email: IconMail,
  Empty: IconWind,
  Export: IconFileExport,
  Filter: IconFilter,
  Folder: IconFolder,
  Help: IconHelp,
  Impersonate: IconSpy,
  Privelege: IconKey,
  Info: IconFileInfo,
  Language: IconLanguage,
  Left: IconChevronLeft,
  Link: IconLink,
  List: IconList,
  Logout: IconLogout,
  Map: IconMap,
  Menu: IconDotsVertical,
  Phone: IconPhone,
  Plus: IconPlus,
  Refresh: IconRefresh,
  Remove: IconX,
  Report: IconReport,
  Right: IconChevronRight,
  Search: IconSearch,
  Send: IconSend,
  Settings: IconSettings,
  Star: IconStar,
  Team: IconUsers,
  Time: IconClock,
  Timezone: IconWorld,
  Up: IconChevronUp,
  User: IconUser,
  Check: IconCheck,

  // Categories
  Category: IconCategory,
  performance: IconStar,
  engagement: IconUserCheck,
  culture: IconConfetti,
  wellbeing: IconHeart,
  // leadership: IconBriefcase,

  // Status
  Success: IconCheck,
  Fail: IconX,
  Visibility: IconLock,

  // Brand Icons
  Apple: IconBrandApple,
  Google: IconBrandGoogle,
  Slack: IconBrandSlack,
  Telegram: IconBrandTelegram,
} satisfies Record<string, Icon>
